import { render, staticRenderFns } from "./BasicExamFinding.vue?vue&type=template&id=bd8cdd06"
import script from "./BasicExamFinding.vue?vue&type=script&lang=js"
export * from "./BasicExamFinding.vue?vue&type=script&lang=js"
import style0 from "./BasicExamFinding.vue?vue&type=style&index=0&id=bd8cdd06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports